import { render } from "./OrganisationUsersAdmin.vue?vue&type=template&id=5d7df9ad"
import script from "./OrganisationUsersAdmin.vue?vue&type=script&lang=js"
export * from "./OrganisationUsersAdmin.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__